import { ReactElement, useMemo } from 'react';

import { Box, FormControlLabel, Radio, Stack, Typography } from '@mui/material';

import StyledCheckbox from './StyledCheckBox';

interface ControlWithLabelProps {
    label: string | ReactElement;
    icon?: ReactElement;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    checked?: boolean;
    controlType?: 'checkbox' | 'radio';
}

export default function ControlWithLabel({
    label,
    icon,
    onChange,
    checked = false,
    controlType = 'checkbox',
}: ControlWithLabelProps) {
    const Label = useMemo(() => {
        return typeof label === 'string' ? <Typography variant="body1">{label}</Typography> : label;
    }, [label]);

    return (
        <Box
            sx={{
                border: '2px solid',
                borderColor: checked ? 'primary.main' : 'gray.300',
                backgroundColor: 'common.white',
                borderRadius: 3,
                cursor: 'pointer',
                p: 2,
            }}
        >
            <FormControlLabel
                sx={{
                    width: '100%',
                    justifyContent: 'space-between',
                    gap: 2.5,
                    margin: 0,
                }}
                label={
                    <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center' }}>
                        {icon && icon}
                        {Label}
                    </Stack>
                }
                labelPlacement="start"
                control={
                    controlType === 'checkbox' ? (
                        <StyledCheckbox checked={checked} onChange={onChange} />
                    ) : (
                        <Radio checked={checked} onChange={onChange} />
                    )
                }
            />
        </Box>
    );
}
